<div style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet o-block u-width-100p _u-width-100p stats-container u-shadow-mini {{
			sectionclass
		}} u-color-white-900 u-bg-accent-2"
	>
		<div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap">
			<div class="o-stack__cell">
				<h5 class="u-color-white-900">{{ sectiontitle }}</h5>
			</div>
		</div>
		<div class="analytics-portlet-content u-pt-small lift_quick_stats_portlet_content r1_ctv_quick_stats">
			<div class="o-stack o-stack--center _u-px-small" *ngIf="quickStatsData && hasData">
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					[attr.title]="metric['title']"
					data-size="big"
					[options]="tooltipOptions"
					*ngFor="let metric of legend"
				>
					<h5 class="u-color-white-900">{{ metric['displayName'] }}</h5>
					<span
						class="u-font-medium u-lh-normal u-opacity-80p"
						*ngIf="quickStatsData[metric.value] && metric['percentValue']; else noPercentageBlock"
					>
						{{ quickStatsData[metric['value'] + 'Percentage']}}%
					</span>
					<div
					    [ngClass]="{'metric-value-percent': metric['percentValue'], 'metric-value-no-percent': !metric['percentValue']}"
						class="u-color-white-900 span_intraction"
						*ngIf="quickStatsData[metric.value]; else noValueBlock"
					>
						{{ quickStatsData[metric.value] | formatNumber }}
					</div>
					<ng-template *ngIf="metric['percentValue']" #completionsRateBlock>
						<div class="u-color-white-900 span_intraction">--</div>
					</ng-template>
					<ng-template #noValueBlock>
						<div class="u-color-white-900 span_intraction">--</div>
					</ng-template>
				</div>
			</div>
			<div class="quick-stats-no-data" *ngIf="!hasData">
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
